import ApiConstants from '../../constants/ApiConstants';
// import checkResults from './checkResults.js';
import xhr from './xhr';

const BookingApiUtils = {
  book(tutorId, startTimestamp, endTimestamp, ticketCost, subTicketCost) {
    return xhr(ApiConstants.book, {
      method: 'post',
      body: JSON.stringify({
        tutor_id: tutorId,
        start_timestamp: startTimestamp,
        end_timestamp: endTimestamp,
        ticket_cost: ticketCost,
        sub_ticket_cost: subTicketCost,
      }),
    });
  },

  cancel(bookingId, page = null) {
    const query = page ? `?page=${page}` : '';
    return xhr(`${ApiConstants.cancelBooking}/${bookingId}${query}`, {
      method: 'delete',
    });
  },

  cancelByTutor(bookingId, reason, comment) {
    return xhr(`${ApiConstants.cancelBookingByTutor}/${bookingId}`, {
      method: 'put',
      body: JSON.stringify({
        reason: reason,
        comment: comment,
      }),
    });
  },

  fetchTutorBookings(tutorId, page) {
    const query = `?page=${page}`;
    return xhr(`${ApiConstants.FetchTutorBookings}/${tutorId}${query}`);
  },

  fetchStudentBookings(studentId, page) {
    const query = `?page=${page}`;
    return xhr(`${ApiConstants.FetchStudentBookings}/${studentId}${query}`);
  },

  fetchMyBookings(page) {
    const query = page ? `?page=${page}` : '';
    return xhr(`${ApiConstants.FetchBookings}${query}`);
  },

  fetchOne(id) {
    return xhr(`${ApiConstants.FetchBooking}/${id}`);
  },
};

export default BookingApiUtils;
